import { configureStore } from '@reduxjs/toolkit'
import uiPropsReducer from "./slice/uiPropsSlice";
import qlikFieldsReducer from "./slice/qlikFieldsSlice";
import qlikObjectReducer from "./slice/qlikObjectSlice"
import qlikVariableReducer from "./slice/qlikVariableSlice"
import qlikSelectionReducer from "./slice/qlikSelectionSlice"
import snackbarReducer from "./slice/snackbarSlice";

export const store = configureStore({
  reducer: {
    uiProps: uiPropsReducer,
    qlikFields: qlikFieldsReducer,
    qlikObject: qlikObjectReducer,
    qlikVariable: qlikVariableReducer,
    qlikSelection: qlikSelectionReducer,
    snackbar: snackbarReducer,
  }
})

// Infer the `RootState` type from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export the store
export default store;